import React from 'react';
import PropTypes from 'prop-types';
var EmptyResultView = function EmptyResultView(_ref) {
  var errorMessage = _ref.errorMessage;
  return /*#__PURE__*/React.createElement("div", {
    className: "resources outer-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "inner-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "empty-error outer-container",
    dangerouslySetInnerHTML: {
      __html: errorMessage
    }
  })));
};
EmptyResultView.propTypes = {
  errorMessage: PropTypes.string.isRequired
};
export default EmptyResultView;